import React from 'react'

function ProductionMethodsHead() {
    return (
        <thead className="TableHead ProductionMethodsHead">
            <tr>
                <th>Tên</th>
                <th>Mã hóa</th>
                <th>Partner sản xuất</th>
                <th>Ngày cập nhật</th>
                <th style={{width: '117px'}}>Hành động</th>
            </tr>
        </thead>
    )
}

export default ProductionMethodsHead